const POViewReducer = (state = {}, action) => {
    switch (action.type) {
        case "getPoSyncErrorListSuccess": {
            return Object.assign({}, state, {
                POSyncErrors: action.data,
            });
            break;
        }
        case "getPODetailsSuccess": {
            return Object.assign({}, state, {
                PODetail: action.data,
            });
            break;
        }
        case "noPoLineItems": {
            return Object.assign({}, state, {
                noPoLineItems: action.data,
            });
            break;
        }
        case "getPOLineItemsSuccess": {
            return Object.assign({}, state, {
                POLineItems: action.data,
            });
            break;
        }
        case "POLineItem":
            return Object.assign({}, state, {
                POLineItem: action.data,
            });
            break;
        case "getCollectMDLineItemsSuccess":
            return Object.assign({}, state, {
                CollectMDLineItems: action.data,
            });
            break;
        case "getCollectMDLineItemsFailure":
            return Object.assign({}, state, {
                CollectMDLineItems: action.data,
            });
            break;
        default: {
            return state;
        }
    }

};
export default POViewReducer;
